import React from 'react';
import { Stack, Typography } from '@mui/material';
import { NewDialogTitle, NewDialogContent } from 'components';

export default function NotFound({ onClose }) {
  return (
    <>
      {/* <NewDialogTitle title="یافت نشد" onClose={onClose} /> */}
      {/* <NewDialogContent isPopup> */}
        <Stack height={320} p={1} flex={1} rowGap={1} bgcolor="background.paper" alignItems="center" justifyContent="center">
          <Typography variant="caption" color="textDisabled">
            متاسفانه موردی یافت نشد.
          </Typography>
        </Stack>
      {/* </NewDialogContent> */}
    </>
  );
}
